import {useContext, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {authAPI} from "../../api/api";
import { Toast } from 'primereact/toast';
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import { Dialog } from 'primereact/dialog';
import "primeflex/primeflex.css";
import "./Login.css"
import styles from "./Login.module.css"
import IG_Logo from '../../common/image/IG logo.jpg'
import {useWindowDimensions} from "../../Context/WindowDimensionsContext";
import {AcceptPolicy} from "./AcceptPolicy/AcceptPolicy"
import loginBg_16_9 from '../../assets/Login_Page/shell-brand-expression-windows-wallpaper-1-3.png';
import loginBg_9_16 from '../../assets/Login_Page/shell-brand-expression-phone-wallpaper-1-2.png';
//import shellLubLabel from '../../assets/shell.svg';
//import igLabel from '../../assets/invent.svg';

import igLabel from '../../assets/Login_Page/IG_Logo.svg';
import HelixLogo from '../../assets/Login_Page/Helix Logo.svg';
import shellLubLabel from '../../assets/Login_Page/ShellLabel.svg';


export const Login = ({setToken, token}) =>{
    const toast = useRef(null);
    const [login, setLogin] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [password, setPassword] = useState("");

    const [acceptPolicyFlag, setAcceptPolicyFlag] = useState(false)
    const [policyAcceptVisible, setPolicyAcceptVisible] = useState(false)

    const buttonRef = useRef(null);

    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    const navigate = useNavigate()

    async  function loginUser() {
        return  await authAPI.login(login, password, acceptPolicyFlag);
    }

    useEffect(() => {
        if(token !== null){
            navigate("/catalog")
        }
    },[])

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            buttonRef.current.click();
        }
    };

    const onHide = () => {
        if (!policyAcceptVisible) return;
        setAcceptPolicyFlag(false) 
        setPolicyAcceptVisible(false);
    }

    const becomeAPartnerButtonHandler = () => {
        window.open('https://docs.google.com/forms/d/e/1FAIpQLSdqUHxv7NT3bFricKsIExDbdayfqu6mXyD33TSoj3MncPK_7Q/viewform', '_blank');
    }

    const handleSubmit = async (e) => {
        debugger
        onHide()
        e.preventDefault()
        const responce = await loginUser();

        const responseData = JSON.parse(responce.data);
        if(responseData.httpStatusCode && responseData.httpStatusCode === 451)
        {
            setPolicyAcceptVisible(true);
            return;
        }
        
        if(responseData.isSucccess){
            debugger
            setToken(responseData.data.token, rememberMe);
            const currentUrl = sessionStorage.getItem('redirectUrl');

            if(currentUrl){
                sessionStorage.removeItem('redirectUrl');
                navigate(currentUrl)

            }
            else{
                navigate("/catalog")
            }
        }
        else{
            toast.current.clear();
            toast.current.show({severity: 'error', summary: 'Помилка', detail: responseData.message, life: 1500});
        }
    }

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Підтвердження</span>
        </div>
    );

    const footerContent = (
        <div>
            <Button label="Далі" onClick={handleSubmit} disabled={!acceptPolicyFlag} autoFocus style={{borderRadius: '10px'}} />
        </div>
    );

    const desktopBgStyle = {
        backgroundImage: `url(${loginBg_16_9})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
    }
    const mobileBgStyle = {
        backgroundImage: `url(${loginBg_9_16})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
    }

    if(viewPortWidth < 1300){
        return (
            <div className={`${styles.wrapper} wrapper`} style={mobileBgStyle}>
                <Toast ref={toast}></Toast>

                {/*absolute*/}
                <img src={igLabel} alt="hyper" className={styles.IGLabel}/>
                <img src={shellLubLabel} alt="hyper" className={styles.shellLabel}/>

                <div className={styles.label_formWrapper}>
                    <div className={styles.helixLogo_PartnerLabelWrapper}>
                        <img src={HelixLogo} alt="hyper"  className={styles.helixLogo}/>
                        <div className={styles.labelBlock}>Кабінет партнера</div>
                    </div>
                    <div className={`${styles.forma}`}>
                        <div className={styles.logo_label}>
                    
                            <img src={IG_Logo} alt="hyper" height={40} className="mb-3"/>
                            <div className="text-3xl font-medium mb-3" style={{color: '#fbfbfb'}}>Вітаємо!</div>
                        </div>
                        <div>
                            <InputText id="email" type="text" onChange={e => setLogin(e.target.value)}
                                       onKeyDown={handleKeyPress} placeholder="Логін" className={`${styles.inputText} w-full mb-3`}/>

                            <InputText id="password" type="password" onChange={e => setPassword(e.target.value)}
                                       onKeyDown={handleKeyPress} placeholder="Пароль" className={`${styles.inputText} w-full mb-3`}/>

                            <div className="flex align-items-center justify-content-between mb-3">
                                <div className="flex align-items-center">
                                    <Checkbox id="rememberme" onChange={e => setRememberMe(e.checked)}
                                              checked={rememberMe}
                                              className="mr-2"/>
                                    <label style={{color: '#E1DEDE'}} htmlFor="rememberme">Запам'ятай мене</label>
                                </div>

                            </div>

                            <div className={styles.buttonBlock}>
                                <Button onClick={handleSubmit} ref={buttonRef} label="Увійти" icon="pi pi-user" type="submit"
                                        className={`w-full ${styles.button}`}
                                        style={{fontWeight: '500'}}/>
                                <Button onClick={becomeAPartnerButtonHandler} label="Стати партнером" type="button"
                                        icon="pi pi-user-plus"
                                        className={`w-full ${styles.button}`}
                                        style={{fontWeight: '500'}}/>
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog visible={policyAcceptVisible} modal  style={{ width: '90vw' }} onHide={onHide} className="acceptPolicyModal">
                    <AcceptPolicy acceptPolicyFlag={acceptPolicyFlag} setAcceptPolicyFlag={setAcceptPolicyFlag} handleSubmit={handleSubmit} />
                </Dialog>
            </div>
        )
    }

    else{
    return (
        <div className={`login ${styles.formaWrapper} `}  style={desktopBgStyle} onSubmit={handleSubmit}>
            <Toast ref={toast}></Toast>

            {/*absolute*/}

            <img src={igLabel} alt="hyper" className={styles.IGLabel}/>
            <img src={shellLubLabel} alt="hyper" height={45} className={styles.shellLabel}/>
            

            <div className={styles.label_formWrapper}>
                <div className={styles.helixLogo_PartnerLabelWrapper}>
                    <img src={HelixLogo} alt="hyper"  className={styles.helixLogo}/>
                    <div className={styles.labelBlock}>Кабінет партнера</div>
                </div>
                <div className={`${styles.forma}`}>
                    <div className={styles.logo_label}>

                        <img src={IG_Logo} alt="hyper" height={45} className="mb-3"/>
                        <div className="text-3xl font-medium mb-3" style={{color: '#fbfbfb'}}>Вітаємо!</div>


                    </div>
                    <div>
                        <InputText id="email" type="text" onChange={e => setLogin(e.target.value)}
                                   onKeyDown={handleKeyPress} placeholder="Логін" className={`${styles.inputText} w-full mb-3`}/>

                        <InputText id="password" type="password" onChange={e => setPassword(e.target.value)}
                                   onKeyDown={handleKeyPress} placeholder="Пароль" className={`${styles.inputText} w-full mb-3`}/>

                        <div className="flex align-items-center justify-content-between mb-3">
                            <div className="flex align-items-center">
                                <Checkbox id="rememberme" onChange={e => setRememberMe(e.checked)} checked={rememberMe}
                                          className="mr-2"/>
                                <label style={{color: '#E1DEDE'}} htmlFor="rememberme">Запам'ятай мене</label>
                            </div>

                        </div>

                        <div className={styles.buttonBlock}>
                            <Button onClick={handleSubmit} ref={buttonRef} label="Увійти" icon="pi pi-user" type="submit"
                                    className={`w-full ${styles.button}`}
                                    style={{fontWeight: '500'}}/>
                            <Button onClick={becomeAPartnerButtonHandler} label="Стати партнером" type="button"
                                    icon="pi pi-user-plus"
                                    className={`w-full ${styles.button}`}
                                    style={{fontWeight: '500'}}/>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog visible={policyAcceptVisible} modal style={{width: '50vw'}} onHide={onHide}
                    className="acceptPolicyModal">
                <AcceptPolicy acceptPolicyFlag={acceptPolicyFlag} setAcceptPolicyFlag={setAcceptPolicyFlag}
                              handleSubmit={handleSubmit}/>
            </Dialog>
        </div>

    )
    }
}